import React, { useState } from 'react';
import { Database } from 'lucide-react';
import CrmV2Page from './CrmV2';
import GroupRecordsView from './GroupRecordsView';

export default function CrmCombined() {
  const [selectedGroup, setSelectedGroup] = useState(null);

  return (
    <div className="min-h-dvh flex flex-col bg-slate-50 text-slate-900 [scrollbar-gutter:stable]">
      <header className="sticky top-0 z-30 shrink-0 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="px-4 py-4">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3 min-w-0">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-teal-50 text-teal-700">
                <Database className="h-6 w-6" />
              </div>
              <div className="min-w-0">
                <h1 className="text-xl font-semibold tracking-tight text-slate-900 truncate">CRM</h1>
                <p className="text-sm text-slate-500 truncate">
                  {selectedGroup ? selectedGroup.groupName : 'Contact lists and records'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 min-h-0 w-full overflow-hidden">
        {!selectedGroup ? (
          <CrmV2Page
            embedded
            groupsOnly
            onSelectGroup={(group) => setSelectedGroup(group)}
          />
        ) : (
          <GroupRecordsView
            group={selectedGroup}
            onBack={() => setSelectedGroup(null)}
          />
        )}
      </main>
    </div>
  );
}
